import { createContext, Dispatch } from "react";
import { history } from "../../browserHistory";
import {
  createContextHook,
  createDispatchHook,
  createProvider,
  createStateHook,
} from "../factory";
import { Action, State } from "./types";
import { reducer } from "./reducer";
import { GroupBy, SortBy } from "../../components/Analysis/utils/types";
import { getCategoryFromQueryString } from "../../components/Analysis/utils";
import {
  GROUP_BY_KEY,
  SORT_BY_KEY,
  INSIGHTS_LS_KEY,
} from "../../components/Analysis/utils/constants";
import { getPersisted } from "../../utils/storage";

const initialState: State = {
  // Request/Processing State
  isLoading: false,
  isLoaded: false,
  isComposed: false,
  isProcessed: false,

  // Data State
  rawData: {
    hit: [],
    site: {},
    rule: {},
    priority: {
      0: [],
      1: [],
      2: [],
    },
    category: {
      performance: [],
      metering: [],
      connectivity: [],
      comfort: [],
      null: [],
    },
  },
  composedFilteredOccurrences: [],
  composedOccurrences: [],
  composedOccurrencesBySite: {},
  composedAndGroupedInsights: [],
  composedAndGroupedOccurrences: [],

  // UI State
  sortDirection: "desc",
  category: getCategoryFromQueryString(history.location.search),
  groupBy:
    getPersisted({ prop: GROUP_BY_KEY, key: INSIGHTS_LS_KEY }, GroupBy.Site) ||
    GroupBy.Site,
  sortBy:
    getPersisted({ prop: SORT_BY_KEY, key: INSIGHTS_LS_KEY }, SortBy.Hits) ||
    SortBy.Hits,
  expandAll: false,
  search: undefined,
};

const stateContext = createContext<State | undefined>(undefined);
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined);

export const InsightsProvider = createProvider(
  stateContext,
  dispatchContext,
  reducer,
  initialState
);
export const useDispatch = createDispatchHook(dispatchContext);
export const useState = createStateHook(stateContext);
export const useInsights = createContextHook(stateContext, dispatchContext);
